import { render } from "./InvoiceChart.vue?vue&type=template&id=68763a41"
import script from "./InvoiceChart.vue?vue&type=script&lang=js"
export * from "./InvoiceChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__